import React from 'react';
import * as XLSX from 'xlsx';
import _ from 'lodash';

const Excel = React.forwardRef((props, ref) => {
	const { filename, data } = props;
	const header = _.keys(data[0]);
	const exportingData = _.map(data, item => _.values(item));

	const handleExport = () => {
		const sheet = XLSX.utils.aoa_to_sheet([header, ...exportingData]);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, sheet, 'sheet1');
		XLSX.writeFile(workbook, `${filename}.xlsx`);
	};

	return (
		<button ref={ref} onClick={handleExport} style={{display: 'none'}}></button>
	);
});

Excel.displayName = 'Excel';

export default Excel;
